<template>
  <div class="product-item" @click="onClick" @mouseleave="showRemark = false">
	<div class="image-container">
	      <el-image  class="img" @mouseenter="showRemark = item.remarkEn ? true : false" :src="joinHead(item.cover)"  lazy :class="{'img-down': showRemark}">
	      </el-image>
		  <div
		    class="remark-container"
		    :class="{'show-remark': showRemark}"
		    v-if="item.remarkEn"
		  >
		    <div class="remark-content">{{ item.remarkEn }}</div>
		  </div>
	      <!-- <i 
	        class="el-icon-news remark-icon" 
	        v-if="item.remarkEn && !showRemark"
	        @mouseenter="showRemark = true"
	      ></i> -->
	    </div>  
	
	  
	  
	  
    <!-- <el-image class="img" :src="joinHead(item.cover)" lazy />
	
	<i class="el-icon-news"></i>
	<div>{{ item.remarkEn }}</div> -->
	
    <div class="title" @click.stop>{{ item.subjectEn }}</div>
    <div class="price" @click.stop>
      {{ currencyConver($store.getters.userInfo.currency) }}{{ item.price }}
      <span v-if="item.maxPrice != item.price"> - {{ item.maxPrice }}</span>
    </div>
    <div class="btn" :class="{'disable': item.isStore}">View Details</div>
  </div>
</template>

<script>
export default {
	data() {
	    return {
	      showRemark: false
	    }
	  },
  props: {
    item: {
      type: Object,
      default() {
        return {}
      }
    },

    type: {
      validator(value) {
      // The value must match one of these strings
        return ['winning', 'private'].includes(value)
      },
      default: 'winning'
    },

    autoJump: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    onClick() {
      if (this.autoJump) {
        const path = `/product/${this.type}ProductDetail/${this.item.id}`
        // console.log(path)
        this.$router.push({ path })
      }
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
.image-container {
  position: relative;
  overflow: hidden;
  
  .img {
    width: 100%;
    height: 216px;
    transition: all 0.3s ease;
    
    &.img-down {
      transform: translateY(100%);
    }
  }

  .remark-icon {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 2;
    font-size: 24px;
    color: rgba(255,255,255,0.8);
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      color: #fff;
      transform: scale(1.1);
    }
  }

  .remark-container {
    position: absolute;
    top: -100%;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.7);
    color: #fff;
    padding: 20px;
	white-space: pre-wrap;
    transition: all 0.3s ease;
    overflow-y: auto;
    z-index: 1;

    &.show-remark {
      top: 0;
    }

    .remark-content {
      max-height: 180px;
      line-height: 1.5;
    }
  }
}
.product-item {
  min-height: 100px;
  background-color: #fff;
  width: 100%;
  box-shadow: 0 0 10px rgba($color: #000000, $alpha: 0.1);
  // .img {
  //   // width: 216px;
  //   width: 100%;
  //   height: 216px;
  // }

  .title {
    color: #666666;
    line-height: 17px;
    font-size: 12px;
    margin-top: 10px;
    margin-bottom: 4px;
    padding: 0 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
  .price {
    padding: 0 10px;
    font-size: 16px;
    color: #333;
    line-height: 22px;
    font-weight: bold;
    margin-bottom: 12px;
  }
  .btn {
    @apply bg-primary;
    // background-color: #f56c6c;
    text-align: center;
    height: 36px;
    line-height: 36px;
    border-radius: 5px;
    color: #fff;
    cursor: pointer;
    font-size: 14px;

    &:hover {
      background-color: #e04040;
    }

    &.disable {
      background: #ec8888 !important;
    }
  }

}
</style>
